import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './components/footer/footer.component';
import { LocationComponent } from './components/location/location.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';

import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ButtonModule } from 'primeng/button';
import { PasswordModule } from 'primeng/password';
import { ToastModule } from 'primeng/toast';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputSwitchModule } from 'primeng/inputswitch';
import { RatingModule } from 'primeng/rating';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TimelineModule } from 'primeng/timeline';
import { PaginatorModule } from 'primeng/paginator';
import { SkeletonModule } from 'primeng/skeleton';
import { ProgressBarModule } from 'primeng/progressbar';
import { SliderModule } from 'primeng/slider';

import { ResetPassFormComponent } from '../account/forgot-password/reset-pass-form/reset-pass-form.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { TimerComponent } from './components/timer/timer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OtpFormComponent } from './../account/otp/otp-form/otp-form.component';
import { AddressComponent } from './components/address/address.component';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { OrderTypeComponent } from './components/order-type/order-type.component';
import { TranslateModule } from '@ngx-translate/core';
import { SwiperModule } from "swiper/angular";
import { FilterQtyPipe } from '../home/pipes/filter-qty.pipe';

import { HeaderComponent } from './components/header/header.component';
import { AddressFormComponent } from './components/address-form/address-form.component';
import { AddressSearchComponent } from './components/address-search/address-search.component';
import { FormDirective } from './../core/directive/form.directive';
import { InputTrimDirective } from './../core/directive/input-trim.directive'

import { OrderQuickAccessSliderComponent } from './components/order-quick-access-slider/order-quick-access-slider.component';
import { PopoularOrderSliderComponent } from './components/popoular-order-slider/popoular-order-slider.component';
import { AddressListComponent } from './components/address-list/address-list.component';
import { OrderItemComponent } from './components/order-item/order-item.component';
import { OrderAmountComponent } from './components/order-amount/order-amount.component';
import { LostNetworkConnectionComponent } from './components/lost-network-connection/lost-network-connection.component';
import { TechnicalErrorComponent } from './components/technical-error/technical-error.component';
import { JsonParsePipe } from '../home/pipes/json-parse.pipe';
import { PopupMessageComponent } from './components/popup-message/popup-message.component';

import { StoreOdrTimeComponent } from '../store/store-odr-time/store-odr-time.component';
import { StoreItemModifierComponent } from '../store/store-item-modifier/store-item-modifier.component';
import { StoreItemContentComponent } from '../store/store-item-content/store-item-content.component';
import { StoreItemListComponent } from '../store/store-item-content/store-item-list/store-item-list.component';
import { StoreItemColumnComponent } from '../store/store-item-content/store-item-column/store-item-column.component';
import { StoreItemSubmodifierComponent } from '../store/store-item-submodifier/store-item-submodifier.component';
import { MobileFloatingCartComponent } from './components/mobile-floating-cart/mobile-floating-cart.component';
import { MixOrderTypeComponent } from '../store/mix-order-type/mix-order-type.component';

import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { EmptyDishMessageComponent } from './components/empty-dish-message/empty-dish-message.component';
import { OutOfServiceMessageComponent } from './components/out-of-service-message/out-of-service-message.component';
import { SocialShareComponent } from './components/social-share/social-share.component';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
import { NgxCopyToClipboardModule } from 'ngx-copy-to-clipboard';
import { FaqComponent } from './components/faq/faq.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { TermNconditionsComponent } from './components/term-nconditions/term-nconditions.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { ActivityTimelineComponent } from './components/activity-timeline/activity-timeline.component';
import { StoreNotFoundErrorComponent } from './components/store-not-found-error/store-not-found-error.component';
import { ProfileNavMobileComponent } from './components/profile-nav-mobile/profile-nav-mobile.component';
import { RemoveAllMessageComponent } from './components/remove-all-message/remove-all-message.component';
import { OrderTypeIconPipe } from './pipes/order-type-icon.pipe';
import { DateTimeSelectionComponent } from './components/date-time-selection/date-time-selection.component';
import { CountdownModule } from 'ngx-countdown';
import { MobileItemCardChannelStoresComponent } from './components/mobile-item-card-channel-stores/mobile-item-card-channel-stores.component';
import { ActivityTimelineIconPipe } from './pipes/activity-timeline-icon.pipe';
import { ItemCardVComponent } from './components/item-card-v/item-card-v.component';
import { MascotLoadingComponent } from './components/mascot-loading/mascot-loading.component';
import { InvalidQrComponent } from './components/invalid-qr/invalid-qr.component';
import { DineInInfoComponent } from './components/dine-in-info/dine-in-info.component';
import { QrDineinSelectionComponent } from './components/qr-dinein-selection/qr-dinein-selection.component';
import { QrCloseMessageComponent } from './components/qr-close-message/qr-close-message.component';
import { QrQuitMessageComponent } from './components/qr-quit-message/qr-quit-message.component';
import { NearbyStoreComponent } from './components/nearby-store/nearby-store.component';
import { LoginMessageComponent } from './components/login-message/login-message.component';
import { ToastComponent } from './components/toast/toast.component';
import { HighlightSearchTextPipe } from './pipes/highlight-search-text.pipe';
import { ModifierPricePipe } from './pipes/modifier-price.pipe';
import { RemoveSelectedItemMessageComponent } from './components/remove-selected-item-message/remove-selected-item-message.component';
import { FormatSubmodifiersPipe } from './pipes/format-submodifiers.pipe';
import { ModQuantityConditionPipe } from './pipes/mod-quantity-condition.pipe';
import { LanguageComponent } from './components/language/language.component';
import { BarcodeGeneratorAllModule, DataMatrixGeneratorAllModule, QRCodeGeneratorAllModule } from '@syncfusion/ej2-angular-barcode-generator';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { FormatTimePipe } from '../shared/pipes/format-time.pipe';
import { PreorderTagComponent } from './components/preorder-tag/preorder-tag.component';
import { StringSplitPipe } from './pipes/string-split.pipe';
import { MenutagIconPipe } from './pipes/menutag-icon.pipe';
import { SkeletonPlaceholderComponent } from './components/skeleton-placeholder/skeleton-placeholder.component';
import { StoreImagePipe } from './pipes/store-image.pipe';
import { SettingsComponent } from './components/profile-nav-mobile/settings/settings.component';
import { QrMobileDetectedComponent } from './components/qr-mobile-detected/qr-mobile-detected.component';
import { NewsComponent } from './components/news/news.component';
import { BannerComponent } from 'src/app/shared/components/banner/banner.component';
import { ChannelNotFoundComponent } from './components/channel-not-found/channel-not-found.component';
import { BarcodeQrcodeComponent } from 'src/app/shared/base-components/barcode-qrcode/barcode-qrcode.component';
import { PlatformSetCPSRPipe } from './pipes/platform-set.pipe';
import { OrderPaidMessageComponent } from './components/order-paid-message/order-paid-message.component';
import { QrScannerComponent } from './base-components/qr-scanner/qr-scanner.component';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { LocationSearchComponent } from './components/location-search/location-search.component';
import { TableNoRequiredComponent } from './components/table-no-required/table-no-required.component';
import { AlcoholConsentMessageComponent } from './components/alcohol-consent-message/alcohol-consent-message.component';
import { OtpToastComponent } from './components/otp-toast/otp-toast.component';
import { MaintenanceComponent } from './components/maintenance/maintenance.component';
import { MenuVariationComponent } from './components/menu-variation/menu-variation.component';
import { SearchFilterComponent } from './components/search-filter/search-filter.component';
import { SortComponent } from './components/sort/sort.component';
import { EmptyFilterMessageComponent } from './components/empty-filter-message/empty-filter-message.component';
import { SubmittingOrderComponent } from './components/submitting-order/submitting-order.component';
import { EditPhoneNumberComponent } from './components/edit-phone-number/edit-phone-number.component';
import { CaptureEmailComponent } from './components/capture-email/capture-email.component';
import { ModGroupProcessPipe } from './pipes/mod-group-process.pipe';
import { ItemTotalPricePipe } from './pipes/item-total-price.pipe';
import { QueueInfoComponent } from './components/queue-info/queue-info.component';
import { QuitQueueMessageComponent } from './components/quit-queue-message/quit-queue-message.component';
import { TelInputCountryCodePipe } from './pipes/tel-input-country-code.pipe';
import { DashedLineComponent } from './components/dashed-line/dashed-line.component';
import { OrderInfoComponent } from './components/order-info/order-info.component';
import { AppliedPromoVoucherComponent } from './components/applied-promo-voucher/applied-promo-voucher.component';
import { CalPriceDiffPipe } from './pipes/cal-price-diff.pipe';
import { NewsDetailComponent } from './components/news-detail/news-detail.component';
import { ItemUnavailableMessageComponent } from './components/item-unavailable-message/item-unavailable-message.component';
import { PlatformSetCSPSRPipe } from './pipes/platform-set-cspsr.pipe';
import { LanguageDescPipe } from './pipes/language-desc.pipe';
import { EvenCenterGiftPipe } from './pipes/even-center-gift.pipe';
import { MiniProgramInfoComponent } from './components/mini-program-info/mini-program-info.component';
import { OverflowFadeDirective } from './directives/overflow-fade.directive';
import { StoreImageHeightDirective } from './directives/store-image-height.directive';
import { SplashCarouselComponent } from './components/splash-carousel/splash-carousel.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { NextAvailableTimePipe } from './pipes/next-available-time.pipe';
import { IsTodayDatePipe } from './pipes/is-today-date.pipe';
import { QueueImagePipe } from './pipes/queue-image.pipe';
import { PaymentMethodDescPipe } from './pipes/payment-method-desc.pipe';
import { StoreMenuTagComponent } from '../store/store-menu-tag/store-menu-tag.component';
import { MenuTagsPipe } from '../store/pipes/menu-tags.pipe';
import { FormatInnerHtmlPipe } from '../store/pipes/format-inner-html.pipe';
import { IsShowMascotPipe } from './pipes/is-show-mascot.pipe';
import { GuestInfoComponent } from './components/guest-info/guest-info.component';
import { MobileHeaderComponent } from './base-components/mobile-header/mobile-header.component';
import { ButtonComponent } from './base-components/button/button.component';
import { BottomActionFooterComponent } from './base-components/bottom-action-footer/bottom-action-footer.component';
import { MembershipCardComponent } from './components/membership-card/membership-card.component';
import { ImageViewerComponent } from './base-components/image-viewer/image-viewer.component';
import { OrderCountdownComponent } from './components/order-countdown/order-countdown.component';
import { WhatsappAuthenticationComponent } from './components/whatsapp-authentication/whatsapp-authentication.component';
import { EorderLandingComponent } from './components/eorder-landing/eorder-landing.component';
import { TermandprivacypolicyComponent } from './base-components/termandprivacypolicy/termandprivacypolicy.component';
import { RateFormComponent } from 'src/app/my-order/rate-form/rate-form.component';

import { DayHoursConverterPipe } from './pipes/day-hours-converter.pipe';
import { PaymentStatusComponent } from './components/payment-status/payment-status.component';
import { GetAvailableItemCountPipePipe } from './pipes/get-available-item-count-pipe.pipe';

import { FilterAddressPipe } from './pipes/filter-address.pipe';
import { EInvoiceFormComponent } from './components/e-invoice-form/e-invoice-form.component';
import { PdpaComponent } from 'src/app/shared/components/pdpa/pdpa.component';
import { MembershipProfileComponent } from './components/membership-profile/membership-profile.component';
import { DialogDefaultsDirective } from './directives/dialog-defaults.directive';

// Note we need a separate function as it's required
// by the AOT compiler.
export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    PageNotFoundComponent,
    TimerComponent,
    ResetPassFormComponent,
    OtpFormComponent,
    LocationComponent,
    AddressComponent,
    OrderTypeComponent,
    FilterQtyPipe,
    AddressFormComponent,
    AddressSearchComponent,
    FormDirective,
    InputTrimDirective,
    OrderQuickAccessSliderComponent,
    PopoularOrderSliderComponent,
    AddressListComponent,
    OrderItemComponent,
    OrderAmountComponent,
    LostNetworkConnectionComponent,
    TechnicalErrorComponent,
    JsonParsePipe,
    PopupMessageComponent,
    StoreOdrTimeComponent,
    StoreItemContentComponent,
    StoreItemListComponent,
    StoreItemColumnComponent,
    StoreItemModifierComponent,
    StoreItemSubmodifierComponent,
    MobileFloatingCartComponent,
    MixOrderTypeComponent,
    EmptyDishMessageComponent,
    OutOfServiceMessageComponent,
    SocialShareComponent,
    FaqComponent,
    PrivacyPolicyComponent,
    TermNconditionsComponent,
    TooltipComponent,
    ActivityTimelineComponent,
    StoreNotFoundErrorComponent,
    ProfileNavMobileComponent,
    RemoveAllMessageComponent,
    OrderTypeIconPipe,
    DateTimeSelectionComponent,
    MobileItemCardChannelStoresComponent,
    ActivityTimelineIconPipe,
    ItemCardVComponent,
    MascotLoadingComponent,
    InvalidQrComponent,
    DineInInfoComponent,
    QrDineinSelectionComponent,
    QrCloseMessageComponent,
    QrQuitMessageComponent,
    NearbyStoreComponent,
    LoginMessageComponent,
    ToastComponent,
    HighlightSearchTextPipe,
    ModifierPricePipe,
    RemoveSelectedItemMessageComponent,
    FormatSubmodifiersPipe,
    ModQuantityConditionPipe,
    LanguageComponent,
    SafeHtmlPipe,
    FormatTimePipe,
    PreorderTagComponent,
    StringSplitPipe,
    MenutagIconPipe,
    SkeletonPlaceholderComponent,
    StoreImagePipe,
    SettingsComponent,
    QrMobileDetectedComponent,
    NewsComponent,
    BannerComponent,
    ChannelNotFoundComponent,
    BarcodeQrcodeComponent,
    PlatformSetCPSRPipe,
    OrderPaidMessageComponent,
    QrScannerComponent,
    LocationSearchComponent,
    TableNoRequiredComponent,
    AlcoholConsentMessageComponent,
    OtpToastComponent,
    MenuVariationComponent,
    SearchFilterComponent,
    SortComponent,
    EmptyFilterMessageComponent,
    SubmittingOrderComponent,
    EditPhoneNumberComponent,
    CaptureEmailComponent,
    ModGroupProcessPipe,
    ItemTotalPricePipe,
    MaintenanceComponent,
    QueueInfoComponent,
    QuitQueueMessageComponent,
    TelInputCountryCodePipe,
    DashedLineComponent,
    OrderInfoComponent,
    AppliedPromoVoucherComponent,
    CalPriceDiffPipe,
    NewsDetailComponent,
    ItemUnavailableMessageComponent,
    PlatformSetCSPSRPipe,
    LanguageDescPipe,
    EvenCenterGiftPipe,
    MiniProgramInfoComponent,
    OverflowFadeDirective,
    StoreImageHeightDirective,
    SplashCarouselComponent,
    NextAvailableTimePipe,
    IsTodayDatePipe,
    QueueImagePipe,
    PaymentMethodDescPipe,
    StoreMenuTagComponent,
    MenuTagsPipe,
    FormatInnerHtmlPipe,
    IsShowMascotPipe,
    GuestInfoComponent,
    MobileHeaderComponent,
    ButtonComponent,
    BottomActionFooterComponent,
    MembershipCardComponent,
    ImageViewerComponent,
    OrderCountdownComponent,
    WhatsappAuthenticationComponent,
    EorderLandingComponent,
    TermandprivacypolicyComponent,
    RateFormComponent,
    OrderCountdownComponent,
    DayHoursConverterPipe,
    PaymentStatusComponent,
    GetAvailableItemCountPipePipe,
    FilterAddressPipe,
    EInvoiceFormComponent,
    PdpaComponent,
    MembershipProfileComponent,
    DialogDefaultsDirective
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgxIntlTelInputModule,
    DropdownModule,
    InputTextModule,
    InputTextareaModule,
    ButtonModule,
    PasswordModule,
    CalendarModule,
    ProgressBarModule,
    ToastModule,
    DialogModule,
    FormsModule,
    ReactiveFormsModule,
    BsDropdownModule.forRoot(),
    RatingModule,
    TranslateModule,
    SwiperModule,
    SelectButtonModule,
    TimelineModule,
    PaginatorModule,
    FormsModule,
    InputSwitchModule,
    LottieModule.forRoot({ player: playerFactory }),
    ShareButtonsModule.withConfig({
      debug: true,
    }),
    ShareIconsModule,
    NgxCopyToClipboardModule,
    CountdownModule,
    BarcodeGeneratorAllModule,
    QRCodeGeneratorAllModule,
    DataMatrixGeneratorAllModule,
    SkeletonModule,
    ZXingScannerModule,
    ProgressSpinnerModule,
    SliderModule,
  ],
  exports: [
    NgxIntlTelInputModule,
    DropdownModule,
    InputTextModule,
    InputTextareaModule,
    ButtonModule,
    PasswordModule,
    CalendarModule,
    ProgressBarModule,
    ToastModule,
    DialogModule,
    FooterComponent,
    TimerComponent,
    ResetPassFormComponent,
    OtpFormComponent,
    HeaderComponent,
    LocationComponent,
    AddressComponent,
    BsDropdownModule,
    RatingModule,
    SelectButtonModule,
    InputSwitchModule,
    SwiperModule,
    TimelineModule,
    PaginatorModule,
    AddressFormComponent,
    AddressSearchComponent,
    OrderQuickAccessSliderComponent,
    PopoularOrderSliderComponent,
    AddressListComponent,
    OrderItemComponent,
    OrderAmountComponent,
    LostNetworkConnectionComponent,
    TechnicalErrorComponent,
    JsonParsePipe,
    PopupMessageComponent,
    StoreOdrTimeComponent,
    StoreItemModifierComponent,
    StoreItemContentComponent,
    StoreItemListComponent,
    StoreItemColumnComponent,
    StoreItemSubmodifierComponent,
    MobileFloatingCartComponent,
    MixOrderTypeComponent,
    EmptyDishMessageComponent,
    OutOfServiceMessageComponent,
    SocialShareComponent,
    LottieModule,
    ShareButtonsModule,
    ShareIconsModule,
    NgxCopyToClipboardModule,
    TooltipComponent,
    ActivityTimelineComponent,
    ProfileNavMobileComponent,
    RemoveAllMessageComponent,
    OrderTypeIconPipe,
    DateTimeSelectionComponent,
    MobileItemCardChannelStoresComponent,
    ActivityTimelineIconPipe,
    ItemCardVComponent,
    DineInInfoComponent,
    QrDineinSelectionComponent,
    QrCloseMessageComponent,
    QrQuitMessageComponent,
    NearbyStoreComponent,
    LoginMessageComponent,
    ToastComponent,
    HighlightSearchTextPipe,
    RemoveSelectedItemMessageComponent,
    FormatSubmodifiersPipe,
    ModQuantityConditionPipe,
    LanguageComponent,
    SafeHtmlPipe,
    FormatTimePipe,
    PreorderTagComponent,
    StringSplitPipe,
    MenutagIconPipe,
    SkeletonPlaceholderComponent,
    SkeletonModule,
    StoreImagePipe,
    QrMobileDetectedComponent,
    BannerComponent,
    BarcodeQrcodeComponent,
    PlatformSetCPSRPipe,
    OrderPaidMessageComponent,
    QrScannerComponent,
    ZXingScannerModule,
    TableNoRequiredComponent,
    AlcoholConsentMessageComponent,
    OtpToastComponent,
    InputTrimDirective,
    MenuVariationComponent,
    SearchFilterComponent,
    SortComponent,
    EmptyFilterMessageComponent,
    SubmittingOrderComponent,
    EditPhoneNumberComponent,
    CaptureEmailComponent,
    QueueInfoComponent,
    QuitQueueMessageComponent,
    BarcodeGeneratorAllModule,
    QRCodeGeneratorAllModule,
    DataMatrixGeneratorAllModule,
    TelInputCountryCodePipe,
    DashedLineComponent,
    OrderInfoComponent,
    AppliedPromoVoucherComponent,
    CalPriceDiffPipe,
    ItemUnavailableMessageComponent,
    PlatformSetCSPSRPipe,
    OrderTypeComponent,
    LocationSearchComponent,
    PlatformSetCSPSRPipe,
    LanguageDescPipe,
    EvenCenterGiftPipe,
    MiniProgramInfoComponent,
    OverflowFadeDirective,
    StoreImageHeightDirective,
    MascotLoadingComponent,
    SplashCarouselComponent,
    ProgressSpinnerModule,
    NextAvailableTimePipe,
    IsTodayDatePipe,
    QueueImagePipe,
    PaymentMethodDescPipe,
    StoreMenuTagComponent,
    MenuTagsPipe,
    FormatInnerHtmlPipe,
    IsShowMascotPipe,
    GuestInfoComponent,
    MobileHeaderComponent,
    ButtonComponent,
    SliderModule,
    BottomActionFooterComponent,
    MembershipCardComponent,
    ImageViewerComponent,
    OrderCountdownComponent,
    WhatsappAuthenticationComponent,
    TermandprivacypolicyComponent,
    RateFormComponent,
    OrderCountdownComponent,
    DayHoursConverterPipe,
    PaymentStatusComponent,
    GetAvailableItemCountPipePipe,
    FilterAddressPipe,
    EInvoiceFormComponent,
    PdpaComponent,
    MembershipProfileComponent,
    DialogDefaultsDirective
  ],

})
export class SharedModule { }
